import { TypedDocumentNode, gql } from '@apollo/client';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';

import { BenchObjectPlayerCell } from '../BenchObjectPlayerCell';
import { BenchObjectStatsCells } from '../BenchObjectStatsCells';
import { BenchObjectTableRow, CellGrow } from '../BenchObjectTable/ui';
import { StartingPriceCell } from '../StartingPriceCell';
import { BenchObjectRow_composeTeamBenchObjectInterface } from './__generated__/index.graphql';

type Props = {
  benchObject: BenchObjectRow_composeTeamBenchObjectInterface;
  onStatsClick: () => void;
  onListingsClick: () => void;
  rarity: Rarity;
  inSeason: boolean;
};

export const BenchObjectRow = ({
  benchObject,
  onStatsClick,
  onListingsClick,
  rarity,
  inSeason,
}: Props) => {
  const { anyPlayer } = benchObject;
  return (
    <BenchObjectTableRow gap={2}>
      <BenchObjectPlayerCell
        anyPlayer={anyPlayer}
        onStatsClick={onStatsClick}
      />
      <BenchObjectStatsCells anyPlayer={anyPlayer} />
      <CellGrow />
      <StartingPriceCell
        anyPlayer={anyPlayer}
        rarity={rarity}
        onListingsClick={onListingsClick}
        inSeason={inSeason}
      />
    </BenchObjectTableRow>
  );
};

BenchObjectRow.fragments = {
  composeTeamBenchObjectInterface: gql`
    fragment BenchObjectRow_composeTeamBenchObjectInterface on ComposeTeamBenchObjectInterface {
      id
      anyPlayer {
        slug
        ...BenchObjectStatsCells_anyPlayer
        ...BenchObjectPlayerCell_anyPlayer
        ...StartingPriceCell_anyPlayer
      }
    }
    ${BenchObjectPlayerCell.fragments.anyPlayer}
    ${BenchObjectStatsCells.fragments.anyPlayer}
    ${StartingPriceCell.fragments.anyPlayer}
  ` as TypedDocumentNode<BenchObjectRow_composeTeamBenchObjectInterface>,
};
